import React from 'react';

const Publications = () => {
  <h3>Publications</h3>;
};

export default Publications;
